import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.003 15.998 27.5 2.25c2.929 2.13 3.667 5.659 3.667 5.659.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-.732 3.497-3.627 5.63L.003 16.001z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M28.907 28.453 4 16 28.91 3.545c1.766 2.02 2.257 4.364 2.257 4.364.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-.484 2.317-2.226 4.33",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "m30.137 13.469-2.095.188-.11 1.829s1.38.997 2.137.997c.906-1.283.755-2.508.068-3.014",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M22.452 15.849c-.66-.02-1.197-.088-.409-1.986-.204-.036-1.302.951-1.92.238-.618-.714 1.116-1.32 1.236-1.605-.012-.214-.276-.38-.036-.844.276-.44 6.89-2.62 8.474-2.652 1.529.583-.612 3.09-1.104 3.222s-1.908 1.177-1.908 1.165c0-.011 2.076 0 2.4.951 0 0-.645 1.013-.972 1.19-.216.116-.877 2.556-3.147 3.47-.23.19-.634-.356-.634-.356.011-.128.418-1.726.146-2.345-.318-.724-2.126-.449-2.126-.449",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M19.825 18.105s.749.443.77.485-.085.4-.085.4l1.37.316s.106-.527.213-.463c.107.063.578.716 1.241.758s.985-.295 1.127-.969.779 0 .67.421c-.256.253-.128.948-.128.948l2.953.696s.15.231-.106.358c0 .02-2.975-.674-2.975-.674l-.556.379 3.21.253s.235.295.064.379c-.214.021-6.27-.421-6.27-.421-2.247.21 2.268.565 2.718.632.45.066 1.725.35 1.861.821-2.687.876-6.355-.821-6.826-1.622 0 0 .021-.569.599-.506.749-.084 1.562.139 1.626.307.185.027 1.113.051 1.113.051s.92-.05.47-.676c-.226-.072-.754-.018-1.09.234-.15-.147-.043-.548-.043-.548l-1.327-.274-.142.356s-.885.118-.885.108c0-.021.15-.758.15-.737 0 .02-.428.042-1.028.484C18.35 19.075 17 18.38 17 18.358c.021 0 1.327-.02 1.926-.358.3.463.706.78.706.78zm-.285-1.185s-.252.219-.506.318c0 0 .91.082 1.369-.348-.23-.21-.61-.215-.61-.215s-.716.01-.793-.234c0 0-1.232.66-.157 1-.152-.4.696-.521.696-.521",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "M19.255 15.742c.146-.139 2.357-1.13 2.703-1.734.51.118 1.364 1.076.957 1.784-.481.293-2.045.507-2.546 1.147-.322.026-1.15.071-1.15.058s-.398-.3-.219-.527c.18-.226.11-.59.255-.728",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagAsm = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagAsm_default = SvgFlagAsm;

export { FlagAsm_default as default };
